import { render, staticRenderFns } from "./ShoppingCartSidebar.vue?vue&type=template&id=20683663&scoped=true&"
import script from "./ShoppingCartSidebar.vue?vue&type=script&lang=js&"
export * from "./ShoppingCartSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingCartSidebar.vue?vue&type=style&index=0&id=20683663&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20683663",
  null
  
)

export default component.exports